import React, { useEffect, useState } from "react";
import axios from "axios";
import { Palmtree, X } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "atr_vacation_banner_dismissed";
let bannerPromise = null;
const fetchBanner = () => {
  if (!bannerPromise) {
    bannerPromise = axios.get(`${API}/api/vacation-banner`).then((r) => r.data).catch(() => null);
  }
  return bannerPromise;
};

export const VacationBanner = () => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetchBanner().then((d) => {
      if (!d?.visible) return;
      try {
        if (sessionStorage.getItem(STORAGE_KEY) === d.message) setDismissed(true);
      } catch { /* ignore */ }
      setData(d);
    });
  }, []);

  if (!data || dismissed) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(STORAGE_KEY, data.message); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div data-testid="vacation-banner" className="relative bg-amber-400 text-black px-10 py-1.5 text-center">
      <p data-testid="vacation-banner-message" className="text-[11px] sm:text-xs font-bold leading-snug inline-flex items-center gap-1.5">
        <Palmtree size={13} className="flex-shrink-0" />
        <span>{data.message}</span>
      </p>
      <button
        onClick={dismiss}
        data-testid="vacation-banner-close"
        aria-label="Fermer"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-black/10 transition-colors"
      >
        <X size={13} />
      </button>
    </div>
  );
};
